<template>
  <div class="container">
    <div class="left-text">
      <div class="text1">交易</div>
      <div class="text2">流程</div>
    </div>
    <div class="right-img">
      <div class="type1">
        <div>
          <img
            src="@/assets/img/流程图1.png"
            style="width: 50px; height: 50px"
          />
        </div>
        <div>项目受理</div>
      </div>
      <div class="type2 el-icon-arrow-right"></div>
      <div class="type1">
        <div>
          <img
            src="@/assets/img/流程图2.png"
            style="width: 50px; height: 50px"
          />
        </div>
        <div>项目挂牌</div>
      </div>
      <div class="type2 el-icon-arrow-right"></div>
      <div class="type1">
        <div>
          <img
            src="@/assets/img/流程图3.png"
            style="width: 50px; height: 50px"
          />
        </div>
        <div>报名登记</div>
      </div>
      <div class="type2 el-icon-arrow-right"></div>
      <div class="type1">
        <div>
          <img
            src="@/assets/img/流程图4.png"
            style="width: 50px; height: 50px"
          />
        </div>
        <div>组织交易</div>
      </div>
      <div class="type2 el-icon-arrow-right"></div>
      <div class="type1">
        <div>
          <img
            src="@/assets/img/流程图5.png"
            style="width: 50px; height: 50px"
          />
        </div>
        <div>成交确认</div>
      </div>
      <div class="type2 el-icon-arrow-right"></div>
      <div class="type1">
        <div>
          <img
            src="@/assets/img/流程图6.png"
            style="width: 50px; height: 50px"
          />
        </div>
        <div>合同签订</div>
      </div>
      <div class="type2 el-icon-arrow-right"></div>
      <div class="type1">
        <div>
          <img
            src="@/assets/img/流程图7.png"
            style="width: 50px; height: 50px"
          />
        </div>
        <div>交易鉴证</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style  scoped>
.container {
  display: flex;
  /* box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.2);
  border: 1px solid red; */
  /* box-shadow: 0px 0px 3px 0px black; */
  margin-bottom: 10px;
  height: auto;
  background-color: #fff;
  padding: 10px 35px;
  box-sizing: border-box;
  width: 1820px !important;
}
.left-text {
  font-size: 40px;
  width: 120px;
}
.text1 {
  color: #fe3030;
}
.text2 {
  /* margin-top: 10px; */
}
.right-img {
  flex: 1;
  /* background-color: pink; */
  display: flex;
  font-size: 20px;
  justify-content: space-between;
}
.right-img > div {
  /* border: 1px solid pink; */
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.type1 {
  flex: 2;
  cursor: pointer;
}
.type2 {
  flex: 1;
  color: #d5d5d5;
  font-size: 40px;
}
.type1:hover {
  color: #6681ea;
}
</style>